import dynamic from 'next/dynamic'
import MainLayout from "@shares/layouts/MainLayout"
import React from "react";
import Head from 'next/head';
import {useTranslation} from "react-i18next";
import { Skeleton } from 'antd-mobile'

export function Loading() {
  return (
    <div className={'px-5 py-4'}>
      <Skeleton.Paragraph
        style={{ height: 40 }}
        className={'mb-2'}
        animated
      />
      <Skeleton.Paragraph
        style={{ height: 40 }}
        animated
      />
    </div>
  )
}

const PageComponent = dynamic(() => import('@features/checkout/pages/index'), {
  loading: () => <Loading />
})

const Page = () => {
    const {t} = useTranslation();
     return (
      <>
        <Head>
          <title>{t('title_checkout')} </title>
        </Head>
        {/* <MainLayout>
          <PageComponent />
        </MainLayout> */}
        <div className="font-bold text-[30px] w-full text-center mt-10">System not supported</div>
      </>
    )
}

export default Page
